import { generateVoiceRecordingName } from '@faceup/utils'
import type { RecordType } from './types'

export const buildRecordingFile = (recording: RecordType): File =>
  new File([recording.data], generateVoiceRecordingName(), { type: 'audio/mpeg' })

export const isRecordType = (value: unknown): value is RecordType =>
  typeof value === 'object' &&
  value !== null &&
  'data' in value &&
  'duration' in value &&
  value.data instanceof Blob
